import { RequestParticipant } from "models/interfaces";

type WithOrder = {
  order: number | string;
};

export const buildVisualList = <T extends WithOrder>(items: T[]) => {
  const map = new Map<number, T[]>();

  items.forEach((s) => {
    const order = Number(s.order);
    if (!map.has(order)) map.set(order, []);
    map.get(order)!.push(s);
  });

  return Array.from(map.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([order, members]) => ({
      order,
      members,
    }));
};

// This Normalize Order Function is used for Signer
export const normalizeOrders = (signers: RequestParticipant[]) => {
  const visual = buildVisualList(signers);

  let nextOrder = 1;
  const result: RequestParticipant[] = [];

  visual.forEach((row) => {
    row.members.forEach((member) => {
      result.push({
        ...member,
        order: nextOrder,
      });
    });
    nextOrder++;
  });

  return result;
};


// This Normalize Order Function is used for Reviewer(Approver)
export const normalizeReviewerOrders = (reviewers: RequestParticipant[]) => {
  const visual = buildVisualList(reviewers);

  let nextOrder = 1;
  const result: RequestParticipant[] = [];

  visual.forEach((row) => {
    // detect existing real group
    const existingGroup = row.members.find(m => m.group)?.group;

    // create label ONLY after final step index is known
    const stepGroup =
      existingGroup ??
      (row.members.length > 1 ? `Group ${nextOrder}` : undefined);

    row.members.forEach(member => {
      result.push({
        ...member,
        order: nextOrder,
        ...(stepGroup !== undefined && { group: stepGroup }),
      });
    });

    nextOrder++;
  });

  return result;
};

export const getGroupDelay = (signers: RequestParticipant[], order: number) => {
  const delayed = signers.find(
    (s) =>
      s.order === order &&
      !s.cc &&
      (s.delayDays || s.delayHours || s.scheduleTime)
  );

  if (!delayed) return null;

  return {
    delayDays: delayed.delayDays,
    delayHours: delayed.delayHours,
    scheduleTime: delayed.scheduleTime,
  };
};
